import React, { useContext, useState } from "react";
import LanguageContext from "../LanguageContext";

import CallIcon from "@mui/icons-material/Call";
import Button from "@mui/material/Button";
import messages from "../services/messages";
import firebase from "../firebase";

export default function HelpCTAButton(props) {
  let { userState, mobile, message, page, section } = props;
  const language = useContext(LanguageContext);
  const [disabledCTA, toggleDisabledCTA] = useState(false);

  return (
    <LanguageContext.Provider value={language}>
      <Button
        startIcon={<CallIcon />}
        variant="contained"
        color="primary"
        href={`tel:${messages["footer.supportNumber"][language]}`}
        disabled={disabledCTA}
        onClick={() => {
          firebase.analytics().logEvent("call_clicked", {
            state_name: userState,
            mobile: mobile ? mobile : null,
            page: page,
            section: section,
            user_type: props.userType,
            user_source: props?.userSource,
          });
        }}
      >
        {message || messages["help.cta.button.text"][language]}
      </Button>
    </LanguageContext.Provider>
  );
}
